

export default {
    kategoriList: [],
    subKategoriList: [],
    totalRecords: 0,
    totalFiltered: 0,
    totalKatRecords: 0,
    totalSubKatRecords: 0,
    totalZaFit : 0
}
